import { useEntityBaseMetadata, useMessagesMetadata } from '@msdk/common'
import { EntityMetadata, FieldDefinition, FormNode, Severity } from '@msdk/definitions'
import { COLORS } from '@msdk/ui'

import { isMessageVisible } from '../utils/validation-visibility'

const severityTypeMap = {
  [Severity.Mandatory]: 20,
  [Severity.Error]: 20,
  [Severity.Warning]: 40,
  [Severity.Info]: 50,
  [Severity.None]: 60,
}

function isValidationColors(value: string): value is keyof typeof COLORS.validation {
  return Object.keys(COLORS.validation).includes(value)
}

function lcfirst(s: string) {
  return s.charAt(0).toLocaleLowerCase() + s.slice(1)
}

export function useFieldSeverity(
  fieldDef: FieldDefinition,
  node: FormNode,
): keyof typeof COLORS.validation | undefined {
  const baseMetadata = useEntityBaseMetadata(fieldDef.entityName) as EntityMetadata
  const messages = useMessagesMetadata(baseMetadata?.msProvider) || []
  const msgToShow = messages.filter((m) => node.value.validationMessages.includes(m.code) && isMessageVisible(m, node))

  const types = msgToShow.map((m) => m.type).map((x) => severityTypeMap[x])
  const mostSevereType = Math.min(...types)
  const severity = lcfirst(Severity[mostSevereType] ?? '')

  return isValidationColors(severity) ? severity : undefined
}
